import { Pipe, PipeTransform } from '@angular/core';
import { min } from 'moment';

@Pipe({
  name: 'timeToHours'
})
export class TimeToHoursPipe implements PipeTransform {

  // For seeing decimal hours in time
  transform(decimalHours: any, ...args: any[]): any {

    // console.log(decimalHours,parseFloat(decimalHours));
    if(isNaN(decimalHours)){
      decimalHours = 8*parseFloat(decimalHours); // because '2 "Days"' would be attached with the string
    }

    // console.log(decimalHours);
    decimalHours = (decimalHours < 0) ? decimalHours * -1 : decimalHours;

    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    const hourLabel = hours === 1 ? 'hr' : 'hrs';
    const minutesLabel = minutes === 1 ? 'min' : 'mins';

    let result = '';
    if( hours > 0) {
      result += `${hours} ${hourLabel}`;
    }
    if (minutes > 0) {
      result += (result ? ' ' : '') + `${minutes} ${minutesLabel}`;
    }

    return result || '0 mins'; // Return '0 mins' if both hours and minutes are zero
  }

}
